import { AuthGuard } from './auth.guard';
import { CanActivateFn, GuardResult, MaybeAsync } from '@angular/router';
import { concatMap, from, last, Observable, of, takeWhile } from 'rxjs';
import { inject, Injector, runInInjectionContext } from '@angular/core';
import { MsalCustomGuard } from './msal-custom.guard';
import { QueryParamsGuard } from './query-param.guard';

export const orderedAsyncGuards = (guards: CanActivateFn[]): CanActivateFn => (route, state) => {
      const injector = inject(Injector);
      return from(guards).pipe(
          concatMap((guard) => runInInjectionContext(injector, () => {
                  const result = guard(route, state);
                  // Ensure the result is an Observable (supports async and sync guards)
                  return resolveType(result);
              })),
          takeWhile((value) => value === true, true),
          last()
      );
  };

const resolveType = (value: MaybeAsync<GuardResult>): Observable<GuardResult> => {
  if (value instanceof Observable) {
      return value;
  }
  if (value instanceof Promise) {
      return from(value);
  }
  return of(value);
};

export const ShellAuthGuard: CanActivateFn = orderedAsyncGuards([MsalCustomGuard, AuthGuard, QueryParamsGuard]);
